import { render, staticRenderFns } from "./CourseDice.vue?vue&type=template&id=cae714a6"
import script from "./CourseDice.vue?vue&type=script&lang=js"
export * from "./CourseDice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports